import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {inject} from 'mobx-react';

const oneLineShopMainTitle = {
    "fontFamily": "GraphikLight",
	  "letterSpacing": ".5px",
    "width": "100%",
    "whiteSpace": "nowrap",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "fontSize": "3em",
    "marginLeft": "1%",
	"textAlign": "left",
};
const multiLineShopMainTitle = {
    "fontFamily": "GraphikLight",
	"letterSpacing": ".5px",
    "marginLeft": "1%",
    "width": "100%",
    "height": "100%",
    "whiteSpace": "wrap",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "fontSize": "2.8em",
    "lineHeight": "1.11em",
	"textAlign": "left",
};

@inject('RootStore')
export default class ShopName extends Component {
    render() {
        let shopMainTitle = oneLineShopMainTitle;
        if(this.props.multiLineShopName) {
            shopMainTitle = multiLineShopMainTitle;
        }

        return (
            <Flexbox flexDirection='column' height="100%" width={this.props.mainDivWidth || '74.5%'} justifyContent={"center"}>
                <div style={{...shopMainTitle, color: this.props.RootStore.styleStore.currentStylesDict.shopNameColor}}>
                    {this.props.name}
                </div>
            </Flexbox>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/live_order_stream_panel/shop_name.jsx